import { useEnrichmentSettings } from '../EnrichmentSettingsProvider/EnrichmentSettingsProvider';
import { useEnrichmentProperties } from './useEnrichmentProperties';
import { usageTracker } from '../../usageTracker';
const trackChangeSetting = ({
  key,
  value
}) => {
  usageTracker.track('changeSetting', {
    action: value ? 'turn on' : 'turn off',
    setting: key
  });
};
export const useSettingsBanner = () => {
  const {
    isContactEnrichment,
    isAutoEnrichmentNudgeOpen,
    onCloseBanner
  } = useEnrichmentProperties();
  const {
    settings,
    onToggleSetting
  } = useEnrichmentSettings();
  const onToggleCompanyEnrichmentAuto = () => {
    const key = 'companyEnrichmentAuto';
    onToggleSetting(key);
    trackChangeSetting({
      key,
      value: !settings.companyEnrichmentAuto
    });
  };
  const onToggleContactEnrichmentAuto = () => {
    const key = 'contactEnrichmentAuto';
    onToggleSetting(key);
    trackChangeSetting({
      key,
      value: !settings.contactEnrichmentAuto
    });
  };
  return {
    companyEnrichmentAuto: settings.companyEnrichmentAuto,
    contactEnrichmentAuto: settings.contactEnrichmentAuto,
    isContactEnrichment,
    onCloseBanner,
    onToggleCompanyEnrichmentAuto,
    onToggleContactEnrichmentAuto,
    isAutoEnrichmentNudgeOpen
  };
};